<template>
  <div class="page-container">
    <div class="page-header-container">
      <div class="header-left">
        <span class="header-left-back" @click="handleToBack">
          <i class="el-icon-arrow-left"></i> <span> 返回</span></span
        >
        <el-divider direction="vertical"></el-divider>
        <span class="header-left-text">专栏建设</span>
      </div>
      <div class="header-center">专栏撰写</div>
      <div class="header-right">
        <el-link
          class="mr-12"
          :underline="false"
          href="https://jiker.feishu.cn/docs/doccnfwavjkQSSxrHTb4432imOh"
          target="_blank"
          ><i class="el-icon-question"></i
        ></el-link>
        <HeaderUser></HeaderUser>
      </div>
    </div>
    <div class="page-content-container">
      <Split class="flex" @onDragEnd="onDragEnd">
        <SplitArea :size="24.8" ref="leftSplit" :max-percent="50">
          <div class="page-content-left">
            <div class="left-header flex">
              <div class="left-header-title">专栏大纲</div>
              <el-button
                size="small"
                @click="handleEditTree"
                class="left-header-btn"
                icon="el-icon-edit"
                v-if="treeDisabled"
                >编辑大纲</el-button
              >
              <div v-else>
                <el-button
                  size="small"
                  @click="handleCancelTree"
                  class="left-header-btn"
                  >取消编辑</el-button
                >
                <el-button
                  size="small"
                  @click="handleSaveTree"
                  class="left-header-btn save"
                  icon="el-icon-finished"
                  type="primary"
                  :loading="saveLoading"
                  >保存大纲</el-button
                >
              </div>
            </div>
            <div class="left-content">
              <el-tree
                :data="treeInfo"
                class="tree-container"
                :props="treeProps"
                ref="tree"
                node-key="uuid"
                :highlight-current="true"
                default-expand-all
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                :check-strictly="true"
                :draggable="!treeDisabled"
                :allow-drag="allowDrag"
                :allow-drop="allowDrop"
                :style="{
                  width: splitWidth + 'px',
                  'max-height': windowHeight - 150 + 'px'
                }"
              >
                <span
                  class="custom-tree-node flex"
                  @dblclick="handleLabelInput(node)"
                  slot-scope="{ node, data }"
                >
                  <span class="tree-label flex">
                    <el-input
                      type="text"
                      :ref="`tree-label-${node.id}`"
                      v-if="
                        !treeDisabled &&
                          node.level != 1 &&
                          chapterId == node.id &&
                          labelInputActive
                      "
                      @blur="handleInputBlur(data)"
                      v-model="data.title"
                      size="mini"
                      class="tree-label-input"
                    ></el-input>
                    <span class="tree-label-title" v-else>
                      {{ data.title }}
                    </span>
                  </span>
                  <span class="tree-label-icon" v-if="!treeDisabled">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="删除“节”"
                      placement="top"
                    >
                      <el-link
                        v-if="node.level !== 1 && !treeDisabled"
                        class="tree-operation"
                        icon="el-icon-remove-outline"
                        type="info"
                        :underline="false"
                        @click="() => remove(node, data)"
                      ></el-link>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="增加“节”"
                      placement="top"
                    >
                      <el-link
                        class="tree-operation add"
                        icon="el-icon-circle-plus-outline"
                        type="info"
                        style="margin-left:4px"
                        :underline="false"
                        @click="append(data)"
                        v-if="!treeDisabled && node.level !== 3"
                      ></el-link>
                    </el-tooltip>
                  </span>
                  <span v-if="treeDisabled && node.level == 3">
                    <span v-if="!data.status" class="tree-info-text none"
                      >未编辑</span
                    >
                    <span
                      class="tree-info-text default"
                      v-else-if="data.status == 1"
                      >已编辑</span
                    >
                    <span
                      class="tree-info-text orange"
                      v-else-if="data.status == 2"
                      >待审核</span
                    >
                    <span
                      class="tree-info-text success"
                      v-else-if="data.status == 3"
                      >已通过</span
                    >
                    <span
                      class="tree-info-text error"
                      v-else-if="data.status == 4"
                      >已拒绝</span
                    >
                  </span>
                </span>
              </el-tree>
            </div>
          </div>
        </SplitArea>
        <SplitArea
          :size="76.2"
          :minSize="60"
          ref="rightSplit"
          :max-percent="50"
        >
          <div class="page-content-right">
            <div class="right-header flex">
              <div class="right-header-title">
                {{ mode == "info" ? "基本信息" : chapterInfo.title }}
                <span
                  class="right-nav-time"
                  v-if="
                    chapterInfo.status > 0 &&
                      chapterDisabled &&
                      chapterInfo.estimate_reading_time_beautify &&
                      mode == 'content'
                  "
                >
                  预计时长：
                  <el-tooltip
                    effect="dark"
                    content="预计时长=总字数/平均阅读速度(500字/min)*60+图片数*5"
                    placement="top"
                  >
                    <i class="el-icon-warning" style="cursor: pointer;"></i>
                  </el-tooltip>
                  {{ chapterInfo.estimate_reading_time_beautify }}</span
                >
              </div>
              <div class="right-header-step" v-if="mode == 'content'">
                <img
                  class="right-step"
                  v-if="!chapterInfo.status"
                  src="../../assets/images/step-1.png"
                />
                <img
                  class="right-step"
                  v-else-if="chapterInfo.status == 1"
                  src="../../assets/images/step-2.png"
                />
                <img
                  v-else-if="chapterInfo.status == 2"
                  class="right-step"
                  src="../../assets/images/step-3.png"
                />
                <img
                  v-else-if="chapterInfo.status == 3"
                  class="right-step"
                  src="../../assets/images/step-4.png"
                />
                <img
                  v-else-if="chapterInfo.status == 4"
                  class="right-step"
                  src="../../assets/images/step-5.png"
                />
                <div
                  @click="getRejectData"
                  v-if="chapterInfo.status == 4"
                  class="right-step-seat"
                ></div>
              </div>
              <el-button
                size="small"
                @click="handleSubmit"
                type="primary"
                class="right-header-btn"
                icon="el-icon-finished"
                v-if="mode == 'content' && [0, 1].includes(chapterInfo.status)"
              >
                提交审核</el-button
              >
            </div>
            <div class="right-content">
              <el-form
                v-if="mode == 'info'"
                :model="editForm"
                label-width="130px"
                :rules="formRule"
                :disabled="disabled"
                size="small"
                ref="editForm"
              >
                <el-form-item
                  label="专栏标题："
                  prop="title"
                  :show-message="false"
                >
                  <el-input
                    v-model="editForm.title"
                    placeholder="请输入专栏标题"
                    maxlength="50"
                    show-word-limit
                    clearable
                    class="w-400"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="专栏短介绍："
                  prop="slogan"
                  :show-message="false"
                >
                  <el-input
                    v-model="editForm.slogan"
                    placeholder="请输入专栏短介绍"
                    maxlength="200"
                    show-word-limit
                    type="textarea"
                    :rows="5"
                    class="w-400"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="专栏简介："
                  prop="briefing"
                  :show-message="false"
                >
                  <el-input
                    v-model="editForm.briefing"
                    placeholder="请输入专栏简介"
                    maxlength="200"
                    show-word-limit
                    type="textarea"
                    :rows="5"
                    class="w-400"
                  ></el-input>
                </el-form-item>
                <el-form-item label="关联行业：">
                  <el-cascader
                    v-model="editForm.common_industries"
                    :options="industryList"
                    :show-all-levels="false"
                    :props="optionProps"
                    placeholder="请选择行业分类"
                    size="small"
                    class="w-220"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item
                  label="难度等级："
                  prop="difficulty_level"
                  :show-message="false"
                >
                  <el-select
                    v-model="editForm.difficulty_level"
                    size="small"
                    placeholder="难度等级"
                    class="w-220 mr-12"
                  >
                    <el-option
                      v-for="item in levelOptions"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <div style="color:#606266;font-weight:500;">
                    共 {{ columnInfo.section_count }} 讲 - 已完成
                    {{ columnInfo.finished_section_count }} 讲 -
                    {{ columnInfo.is_finished ? "已完结" : "暂未完结" }}
                  </div>
                </el-form-item>
                <el-form-item
                  label="相关技能："
                  prop="stacks"
                  :show-message="false"
                >
                  <div class="flex">
                    <div v-if="editForm.stacks.length" class="flex">
                      <el-tag
                        class="course-tag mr-12"
                        v-for="(tag, index) in editForm.stacks"
                        :key="tag.id"
                        :closable="!disabled"
                        type="info"
                        size="small"
                        @close="handleDeleteSkill(index)"
                      >
                        {{ tag.name }}
                      </el-tag>
                    </div>
                    <SelectSkill
                      :value.sync="editForm.stack"
                      class="w-220"
                      showTag
                      @change="handleAddTag"
                    ></SelectSkill>
                  </div>
                </el-form-item>
                <el-form-item label="你将收获：" :show-message="false">
                  <div
                    style="display:inline-flex;"
                    v-if="editForm.rewards.length"
                  >
                    <el-tag
                      class="course-tag mr-12"
                      v-for="(tag, index) in editForm.rewards"
                      :key="index"
                      :closable="!disabled"
                      type="info"
                      size="small"
                      @close="editForm.rewards.splice(index, 1)"
                    >
                      {{ tag }}
                    </el-tag>
                  </div>
                  <el-input
                    size="mini"
                    class="w-180"
                    v-model="reward"
                    @keyup.enter.native="
                      handleRewardCreate(reward, editForm.rewards)
                    "
                    placeholder="请输入内容"
                  ></el-input>
                </el-form-item>
                <el-form-item label="适合人群：" :show-message="false">
                  <div
                    style="display:inline-flex;"
                    v-if="editForm.adapt.length"
                  >
                    <el-tag
                      class="course-tag mr-12"
                      v-for="(tag, index) in editForm.adapt"
                      :key="index"
                      :closable="!disabled"
                      type="info"
                      size="small"
                      @close="editForm.adapt.splice(index, 1)"
                    >
                      {{ tag }}
                    </el-tag>
                  </div>
                  <el-input
                    size="mini"
                    class="w-180"
                    v-model="adapt"
                    @keyup.enter.native="handleAdaptCreate"
                    placeholder="请输入内容"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="相关岗位："
                  prop="job_id"
                  :show-message="false"
                >
                  <CascaderPosition
                    size="mini"
                    placeholder="请选择岗位方向"
                    :jobId.sync="editForm.job_id"
                    :emitPath="false"
                    @getNodes="handleGetJob"
                  ></CascaderPosition>
                </el-form-item>
                <el-form-item
                  label="专栏封面："
                  prop="cover_file_id"
                  :show-message="false"
                >
                  <UploadImage
                    uploadWidth="upload-w-397"
                    :cover_url.sync="editForm.url"
                    :cover_file_id.sync="editForm.cover_file_id"
                    :disabled="disabled"
                    :api="API"
                    space="_for_column_sub_project"
                    :watermark="watermark"
                  ></UploadImage>
                  <el-alert
                    title="建议上传的封面大小为590*340像素的图片"
                    type="warning"
                    style="height:34px;width:397px;margin-top:12px;"
                    show-icon
                  >
                  </el-alert>
                </el-form-item>
                <el-form-item
                  label="专栏详细介绍："
                  prop="introduction"
                  :show-message="false"
                >
                  <MarkDown
                    :value.sync="editForm.introduction"
                    :defaultOpen="disabled ? 'preview' : 'edit'"
                    :disabled="disabled"
                    space="_for_column_sub_project"
                    folder="service_admin"
                  ></MarkDown>
                </el-form-item>
              </el-form>
              <div class="right-content-box" v-else>
                <div class="right-content-text">正文</div>
                <MarkDown
                  :key="chapterInfo.id"
                  :autofocus="false"
                  class="right-content-markdown"
                  :value.sync="chapterInfo.content"
                  space="_for_skill_sub_project"
                  folder="admin"
                  :disabled="chapterDisabled"
                  :defaultOpen="chapterDisabled ? 'preview' : 'edit'"
                ></MarkDown>
                <div class="right-content-foot flex">
                  <div class="flex">
                    <div class="right-content-annex">附件：</div>
                    <UploadFile
                      :file.sync="chapterInfo.attachment"
                      :api="API"
                      space="_for_challenge_sub_project"
                      folder="fuwu"
                      needCallback
                      @cb="handleUploadCallback"
                    ></UploadFile>
                  </div>
                  <el-button
                    class="right-content-btn"
                    @click="handleSave"
                    v-if="!chapterInfo.content || !chapterDisabled"
                    type="primary"
                    >保存</el-button
                  >
                  <el-button
                    class="right-content-btn"
                    @click="chapterDisabled = false"
                    v-else-if="
                      [0, 1, 4].includes(chapterInfo.status) && chapterDisabled
                    "
                    type="primary"
                    >编辑</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </SplitArea>
      </Split>
    </div>
    <el-button
      type="primary"
      class="page-btn"
      size="medium"
      round
      icon="el-icon-edit"
      @click="handleClickBtn"
      v-if="mode == 'info'"
    >
      {{ disabled ? "立即编辑" : "立即保存" }}</el-button
    >
    <el-drawer
      :visible.sync="rejectDrawer"
      :size="560"
      :with-header="false"
      direction="rtl"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="rejectDrawer-box" v-loading="drawerLoading">
        <div class="rejectDrawer-header flex">
          <div>驳回信息</div>
          <i class="el-icon-close" @click="rejectDrawer = false"> </i>
        </div>
        <div class="rejectDrawer-body">
          <div class="reject-item">
            <div
              class="reject-item-info "
              v-for="(item, index) in rejectInfo"
              :key="index"
            >
              <div class="flex" style="justify-content: space-between;">
                <div>时间：{{ item.created_at }}</div>
                <div>操作人：{{ item.creator }}</div>
              </div>
              <div class="reject-item-content">
                <markdown-it-show
                  :md="item.reason || item.action_label"
                ></markdown-it-show>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import columnService from "@/global/service/column";
import MarkDown from "@/components/Markdown";
import UploadImage from "@/components/UploadImage.vue";
import UploadFile from "@/components/UploadFile.vue";
import CascaderPosition from "../Challenge/widgets/CascaderPosition.vue";
import kcellService from "@/global/service/kcell";
import SelectSkill from "@/components/SelectSkill.vue";
import API from "@/global/request/api";
import MarkdownItShow from "@jiker/markdown-it/MarkdownIt.vue";
import HeaderUser from "../../components/HeaderUser.vue";

export default {
  computed: {
    ...mapState(["userAvatar", "userName", "authPermissions"])
  },
  components: {
    MarkDown,
    UploadImage,
    CascaderPosition,
    SelectSkill,
    UploadFile,
    MarkdownItShow,
    HeaderUser
  },
  mounted() {
    this.windowHeight = document.documentElement.clientHeight;
    this.rightWidth = this.$refs["rightSplit"].$el.clientWidth;
    window.addEventListener("resize", () => {
      this.windowHeight = document.documentElement.clientHeight;
    });
  },
  data() {
    return {
      id: this.$route.params.id,
      rejectDrawer: false,
      rejectInfo: [],
      mode: "info",
      columnInfo: {},
      treeInfo: [],
      treeProps: {
        label: "title",
        children: "sections"
      },
      levelOptions: [
        {
          label: "L1 - 入门",
          value: 1
        },
        {
          label: "L2 - 初阶",
          value: 2
        },
        {
          label: "L3 - 中阶",
          value: 3
        },
        {
          label: "L4 - 高阶",
          value: 4
        },
        {
          label: "L5 - 资深",
          value: 5
        },
        {
          label: "L6 - 专家",
          value: 6
        }
      ],
      editForm: {
        title: "",
        introduce: "",
        level: null,
        stacks: [],
        stack: null,
        job_id: null,
        common_industries: [],
        url: "",
        cover_file_id: null,
        teacher_uid: "",
        price: null,
        rewards: [],
        adapt: []
      },
      reward: null,
      adapt: null,
      formRule: {
        title: { required: true, trigger: "blur" },
        briefing: { required: true, trigger: "blur" },
        slogan: { required: true, trigger: "blur" },
        level: { required: true, trigger: "change" },
        stacks: { required: true },
        job_id: { required: true },
        cover_file_id: { required: true },
        introduction: { required: true },
        teacher_uid: { required: true },
        price: { required: true }
      },
      treeDisabled: true,
      windowHeight: null,
      splitWidth: null,
      treeStorage: [],
      API: API.columnFile,
      watermark: process.env.VUE_APP_JK_WATERMARK_QUERY,
      disabled: true,
      chapterDisabled: false,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
        emitPath: false
      },
      managers: [],
      searchLoading: false,
      chapterInfo: {},
      saveLoading: false,
      chapterId: "",
      labelInputActive: false,
      drawerLoading: false
    };
  },
  created() {
    this.getData();
    this.getContent();
  },
  methods: {
    getContent() {
      kcellService.kcellIndustryList().then(res => {
        this.industryList = res;
      });
    },
    getData() {
      columnService.getColumnsInfo(this.id).then(res => {
        this.editForm = {
          title: res.title,
          introduction: res.introduction,
          difficulty_level: res.difficulty_level,
          stacks: res.stacks,
          stack: null,
          job_id: res.job_id,
          url: res.cover.path,
          cover_file_id: res.cover_file_id,
          briefing: res.briefing,
          slogan: res.slogan,
          common_industries: res.common_industries.map(data => {
            return data.id;
          }),
          teacher_uid: res.teacher_uid,
          price: res.price,
          adapt: res.adapt ? res.adapt : [],
          rewards: res.rewards ? res.rewards : []
        };
        this.treeInfo = [{ title: res.title, sections: res.chapters }];
        this.columnInfo = {
          section_count: res.section_count,
          finished_section_count: res.finished_section_count,
          is_finished: res.is_finished
        };
      });
    },
    handleToBack() {
      this.$router.back();
    },
    handleLabelInput(node) {
      if (node.level != 1 && !this.treeDisabled) {
        this.labelInputActive = true;
        this.chapterId = node.id;
        this.$nextTick(() => {
          this.$refs[`tree-label-${node.id}`].focus();
        });
      }
    },
    handleInputBlur(data) {
      if (!data.title) {
        return this.$message.error("专栏标题不能为空！");
      }
      this.labelInputActive = false;
    },
    onDragEnd() {
      this.splitWidth = this.$refs["leftSplit"].$el.clientWidth;
      this.rightWidth = this.$refs["rightSplit"].$el.clientWidth;
    },
    handleEditTree() {
      if (!this.disabled) {
        return this.$message.warning("请先保存基本信息再进行编辑大纲");
      }
      this.treeStorage = JSON.parse(JSON.stringify(this.treeInfo));
      this.treeDisabled = false;
    },
    handleCancelTree() {
      this.treeDisabled = true;
      this.treeInfo = this.treeStorage;
    },
    handleGetJob(e) {
      this.editForm.job_id = e.map(s => s.value);
    },
    handleNodeClick(e, node) {
      if (!this.disabled) {
        return this.$message.warning("请先保存当前，再切换信息");
      }
      if (!e.id) {
        this.mode = "info";
        return;
      }
      if (!this.treeDisabled) {
        return;
      }
      if (node.level !== 3) {
        return;
      }
      this.mode = "content";
      this.chapterInfo = e;
      this.chapterDisabled = this.chapterInfo.content ? true : false;
    },
    append(data) {
      data.sections.push({
        title: "NewNode",
        sections: []
      });
    },
    handleSave() {
      if (!this.chapterInfo.content) {
        return this.$message.error("请输入专栏内容");
      }
      const params = {
        content: this.chapterInfo.content
      };
      columnService
        .submitColumnsNodeContent(this.id, this.chapterInfo.id, params)
        .then(res => {
          this.$message.success("保存信息成功");
          this.chapterInfo.status = 1;
          this.chapterInfo.estimate_reading_time_beautify =
            res.estimate_reading_time_beautify;
          this.chapterDisabled = true;
        });
    },
    handleSaveTree() {
      this.saveLoading = true;
      const params = {
        chapters: this.treeInfo[0].sections
      };
      columnService
        .updateColumnsPrecis(this.id, params)
        .then(() => {
          this.treeDisabled = true;
          this.$message.success("保存成功");
          this.getData();
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    getRejectData() {
      this.drawerLoading = true;
      columnService
        .submitColumnsNodeContentVerifyInfo(this.id, this.chapterInfo.id)
        .then(res => {
          this.rejectInfo = res;
          this.rejectDrawer = true;
        })
        .finally(() => {
          this.drawerLoading = false;
        });
    },
    handleSubmit() {
      if (this.chapterInfo.status == 1) {
        columnService
          .submitColumnsNodeContentVerify(this.id, this.chapterInfo.id)
          .then(() => {
            this.chapterInfo.status = 2;
            this.$message.success("提交审核成功");
          });
      } else {
        this.$message.warning("请先保存专栏内容后再进行提交审核");
      }
    },
    handleClickBtn() {
      if (!this.treeDisabled) {
        return this.$message.warning("请先保存大纲再进行编辑基本信息");
      }
      this.disabled = !this.disabled;
      if (this.disabled) {
        this.$refs["editForm"].validate(valid => {
          if (!valid) {
            this.$message.error("缺少必要参数");
            return;
          }
          this.contentLoading = true;
          const params = {};
          for (let key in this.editForm) {
            if (key !== "url") {
              if (key === "stack") {
                params[key] = this.editForm["stacks"].map(id => id.id);
              } else {
                params[key] = this.editForm[key];
              }
            }
          }
          delete params.stacks;
          columnService
            .updateColumnsInfo(this.id, params)
            .then(() => {
              this.disabled = true;
              this.getData();
              this.$message.success("基本信息保存成功");
            })
            .finally(() => {
              this.contentLoading = false;
            });
        });
      }
    },
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.sections;
      const index = children.indexOf(data);
      this.$confirm("此操作将会删除该章节, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          children.splice(index, 1);
        })
        .catch(() => {
          return;
        });
    },
    handleAddTag(e) {
      if (!this.editForm.stacks?.find(s => s.id === e.id)) {
        this.editForm.stacks.push(e);
      } else {
        return this.$message.error("请勿添加重复技能点");
      }
    },
    allowDrag(dragNode) {
      return [2, 3].includes(dragNode.level);
    },
    allowDrop(draggingNode, dropNode, type) {
      if (
        draggingNode.level === dropNode.level &&
        draggingNode.parent.id == dropNode.parent.id
      ) {
        return type === "prev" || type === "next";
      } else {
        return false;
      }
    },
    handleUploadCallback(e) {
      columnService.updateColumnsAttachment(this.id, this.chapterInfo.id, {
        attachment_file_id: e
      });
    },
    handleDeleteSkill(index) {
      this.editForm.stacks.splice(index, 1);
    },
    handleRewardCreate() {
      if (
        this.editForm.rewards.length > 0 &&
        this.editForm.rewards.includes(this.reward)
      ) {
        return this.$message.error("已存在，请勿重复添加");
      }
      this.editForm.rewards.push(this.reward);
      this.reward = null;
    },
    handleAdaptCreate() {
      if (
        this.editForm.adapt.length > 0 &&
        this.editForm.adapt.includes(this.adapt)
      ) {
        return this.$message.error("已存在，请勿重复添加");
      }
      this.editForm.adapt.push(this.adapt);
      this.adapt = null;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.auto-textarea-input {
  padding-top: 6px !important;
}
.upload-box {
  display: flex;
  align-items: center;
  /deep/.ellipsis {
    margin-left: 12px;
  }
}
.page-btn {
  position: fixed;
  bottom: 56px;
  right: 32px;
  z-index: 1501;
  width: 112px;
  height: 38px;
}
.tree-label-input {
  /deep/.el-input__inner {
    height: 24px !important;
    line-height: 24px !important;
    padding-left: 10px;
  }
}
.el-button--medium.is-round {
  padding: 10px;
}
.rejectDrawer-box {
  height: 100%;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  .rejectDrawer-header {
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    i {
      cursor: pointer;
    }
  }
  .rejectDrawer-body {
    padding: 0 24px 20px;
    .reject-item {
      .reject-item-info {
        justify-content: space-between;
        font-size: 14px;
        margin-top: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        .reject-item-content {
          margin-top: 12px;
          width: 100;
          padding: 16px;
          background: rgba(0, 0, 0, 0.02);
          border-radius: 2px;
        }
      }
    }
  }
}
.flex {
  display: flex;
  align-items: center;
}
/deep/.el-button [class*="el-icon-"] + span {
  margin-left: 3px;
}
/deep/.el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
//一级节点选择器
/deep/ .el-tree > .el-tree-node > .el-tree-node__content {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85) !important;
  font-family: PingFangSC-Medium, PingFang SC;
}
/deep/
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .el-tree-node
  > .el-tree-node__content {
  font-family: PingFangSC-Regular, PingFang SC !important;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
/deep/.el-tree-node__content {
  margin-bottom: 6px;
}

/deep/.el-tree-node__content:hover {
  background: #f5f5f5;
}
/deep/.el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: #f5f5f5;
}
.page-container {
  position: relative;
  min-width: 1440px;
  height: 100vh;
  width: 100%;
  background: #f2f3f5;
  .page-header-container {
    padding: 20px 24px;
    width: 100%;
    height: 72px;
    background: #fff;
    box-shadow: 0px 1px 2px 0px rgba(217, 217, 217, 0.83);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .header-center {
      position: absolute;
      left: 50%;
      line-height: 70px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #409eff;
      border-bottom: 2px solid #409eff;
    }
    .header-left {
      .header-left-back {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        &:hover {
          color: rgba(0, 0, 0, 0.65);
        }
      }
      .header-left-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      .page-header-right {
        display: flex;
        align-items: center;
        padding: 0 20px;
        height: 100%;
        transition: all 0.2s ease;
        cursor: pointer;
        // &:hover {
        //   background: #ecf5ff;
        // }
        .user-avatar {
          margin-right: 12px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
        }
        .user-name {
          margin-right: 12px;
          font-size: 14px;
        }
      }
    }
  }
  .page-content-container {
    width: 100%;
    padding: 24px;
    height: calc(100vh - 72px);
    .page-content-left {
      width: 100%;
      height: 100%;
      .left-header {
        width: 100%;
        height: 56px;
        background: #fafafa;
        // box-shadow: inset 0px -1px 0px 0px #eaeaea;
        justify-content: space-between;
        padding: 0 24px;
        border-bottom: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        .left-header-btn {
          width: 80px;
          height: 24px;
          border-radius: 2px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          // color: rgba(0, 0, 0, 0.65);
          padding: 4px 8px;
        }
        .left-header-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
      }
      .left-content {
        border-right: 1px solid #e5e5e5;
        height: calc(100% - 56px);
        .tree-container {
          height: 100%;
          background: #ffffff;
          padding: 24px;
          overflow-y: auto;
          .custom-tree-node {
            width: 100%;
            padding-right: 8px;
            justify-content: space-between;
            .tree-info-text {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              &.none {
                color: #c9c9c9;
              }
              &.default {
                color: #68718e;
              }
              &.success {
                color: #53bd6f;
              }
              &.error {
                color: #f67e7e;
              }
              &.orange {
                color: #fa8c16;
              }
            }
            .tree-label {
              .tree-label-title {
                font-size: 14px;
              }
            }
            .tree-operation {
              color: rgba(0, 0, 0, 0.85);
              margin-right: 4px;
              &.add:hover {
                color: #409eff;
              }
              &:hover {
                color: #f56c6c;
              }
            }
            .tree-label-icon {
              right: 16px;
            }
          }
        }
      }
    }
    .page-content-right {
      width: 100%;
      height: 100%;
      .right-header {
        width: 100%;
        height: 56px;
        background: #fafafa;
        border-bottom: 1px solid #e5e5e5;
        border-left: 1px solid #e5e5e5;
        padding: 16px 24px;
        justify-content: space-between;
        position: relative;
        .right-header-step {
          position: absolute;
          left: 38%;
          top: 32%;
          .right-step {
            height: 20px;
            object-fit: cover;
          }
          .right-step-build {
            position: relative;
          }
          .right-step-seat {
            width: 160px;
            height: 20px;
            opacity: 0;
            right: 0;
            top: 0;
            position: absolute;
            cursor: pointer;
          }
        }
        .right-header-title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          line-height: 24px;
          .right-nav-time {
            font-size: 13px;
            margin-left: 20px;
            color: rgba(0, 0, 0, 0.65);
          }
        }
        .right-header-btn {
          width: 100px;
          height: 32px;
          font-size: 14px;
          padding: 4px;
        }
      }
      .right-content {
        overflow-y: auto;
        border-left: 1px solid #e5e5e5;
        height: calc(100% - 56px);
        width: 100%;
        background: #fff;
        padding: 32px;
        .right-content-box {
          height: 100%;
          .right-content-text {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #bfbfbf;
            margin-bottom: 10px;
          }
          .right-content-markdown {
            height: 84%;
            /deep/.markdown-body {
              height: 100% !important;
            }
          }
          .right-content-foot {
            margin-top: 18px;
            justify-content: space-between;
            .right-content-btn {
              height: 40px;
              width: 160px;
              padding: 4px;
              font-size: 16px;
            }
            .right-content-annex {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.45);
            }
          }
        }
      }
    }
  }
}

.dropdown-item {
  color: #606266;
}
.dropdown-user {
  width: 176px;
  height: 132px;
  padding: 14px 24px 24px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  margin-bottom: 4px;
  .dropdown-user-img {
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
  .dropdown-user-name {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin-top: 8px;
  }
}
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #f0f2f5;
  color: #666666;
  // .dropdown-item {
  //   color: #66b1ff;
  // }
}
</style>
